export default "__VITE_ASSET__DsitNFgE__"